import { render } from "./landingpage.vue?vue&type=template&id=9ed29f76"
import script from "./landingpage.vue?vue&type=script&lang=js"
export * from "./landingpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__